<header>
  <div class="header-spacer" aria-hidden="true"></div>
  <h1 class="sm-text-xl sm-font-medium sm-flex sm-justify-center sm-flex-1" i18n>Add new list</h1>
  <button
    class="header-control"
    type="button"
    aria-label="Cancel list creation."
    (click)="cancelListCreation()"
    data-test="cancel-button"
  >
    <em class="cc-icon cc-icon-close" aria-hidden="true"></em>
  </button>
</header>

<form (submit)="createList($event)">
  <label class="list-name-container" for="list-name-input">
    <p class="list-name-label">
      <span i18n>List Name</span>
      <cc-tool-tip contentKey="addListNameHelper"></cc-tool-tip>
    </p>
      <cc-text-input
        id="list-name-input"
        width="250px"
        placeholder="e.g. Plant list"
        [(value)]="listName"
      ></cc-text-input>
  </label>
  <button
    class="add-list-button"
    type="submit"
    [attr.aria-disabled]="isSaving || listName === ''"
    [class.disabled]="isSaving || listName === ''"
  >
    Add list
  </button>
</form>
